import { addSheetBackLink, PARENT_SHEETS } from "../sheetNavigation";
import {
  COL_D,
  COL_E,
  COL_F,
  COL_G,
  COL_H,
  COL_I,
  COL_J,
  HEADER_FILL,
  TABLE_HEADER_FILL,
  formatPercent,
  formatNumber,
  mergeRow,
  safeText,
  setCell,
} from "./principle6SheetHelpers";
import { filterPopulatedRows, setStandardDetailWidths } from "./principle8SheetHelpers";

const TITLE_ROW = 3;
const HEADER_ROW = 4;
const DATA_START_ROW = 5;

export const SHEET_NAME = "Project for rehabilitation";

const SHEET_TITLE =
  "Provide information on project(s) for which ongoing Rehabilitation and Resettlement (R&R) is being undertaken by your entity, in the following format";

export function buildProjectForRehabilitationSheet(workbook, sectionC) {
  const ws = workbook.addWorksheet(SHEET_NAME, { views: [{ showGridLines: true }] });
  setStandardDetailWidths(ws, { D: 8, E: 24, F: 12, G: 14, H: 18, I: 16, J: 18 });

  const rows = filterPopulatedRows(
    sectionC?.principle8?.essentialIndicators?.rehabilitationAndResettlement,
    [
      "projectName",
      "state",
      "district",
      "numberOfProjectAffectedFamilies",
      "percentagePAFsCoveredByRR",
      "amountsPaidToPAFs",
    ]
  );

  addSheetBackLink(ws, PARENT_SHEETS.PRINCIPLE_8, { mergeEnd: COL_J });

  mergeRow(ws, TITLE_ROW, COL_D, COL_J, SHEET_TITLE, {
    bold: true,
    fill: HEADER_FILL,
    align: "center",
  });

  setCell(ws, HEADER_ROW, COL_D, "Sr. No.", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, HEADER_ROW, COL_E, "Name of Project for which R&R is ongoing", {
    bold: true,
    fill: TABLE_HEADER_FILL,
    align: "center",
  });
  setCell(ws, HEADER_ROW, COL_F, "State", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, HEADER_ROW, COL_G, "District", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, HEADER_ROW, COL_H, "No. of Project Affected Families (PAFs)", {
    bold: true,
    fill: TABLE_HEADER_FILL,
    align: "center",
  });
  setCell(ws, HEADER_ROW, COL_I, "% of PAFs covered by R&R", {
    bold: true,
    fill: TABLE_HEADER_FILL,
    align: "center",
  });
  setCell(ws, HEADER_ROW, COL_J, "Amounts paid to PAFs in the FY (In INR)", {
    bold: true,
    fill: TABLE_HEADER_FILL,
    align: "center",
  });

  rows.forEach((item, idx) => {
    const row = DATA_START_ROW + idx;
    setCell(ws, row, COL_D, String(idx + 1), { align: "center" });
    setCell(ws, row, COL_E, safeText(item?.projectName), { align: "left" });
    setCell(ws, row, COL_F, safeText(item?.state), { align: "left" });
    setCell(ws, row, COL_G, safeText(item?.district), { align: "left" });
    setCell(ws, row, COL_H, formatNumber(item?.numberOfProjectAffectedFamilies), { align: "center" });
    setCell(ws, row, COL_I, formatPercent(item?.percentagePAFsCoveredByRR), { align: "center" });
    setCell(ws, row, COL_J, formatNumber(item?.amountsPaidToPAFs), { align: "center" });
  });

  return ws;
}
